// Firestore 12 references Temporal types, which the ES2022 lib does not
// include.
import type {} from 'temporal-spec/global';
import { InjectionToken } from '@angular/core';
import { FirebaseApp } from 'firebase/app';
import { Auth, signInWithCustomToken, UserCredential } from 'firebase/auth';
import {
  collection,
  CollectionReference,
  DocumentData,
  Firestore,
  limit,
  onSnapshot,
  orderBy,
  Query,
  query,
  QueryConstraint,
  QuerySnapshot,
  where,
  WhereFilterOp
} from 'firebase/firestore';

export const FIREBASE_APP = new InjectionToken<FirebaseApp>('FIREBASE_APP');
export const FIREBASE_AUTH = new InjectionToken<Auth>('FIREBASE_AUTH');
export const FIREBASE_FIRESTORE = new InjectionToken<Firestore>(
  'FIREBASE_FIRESTORE'
);

export interface FirebaseSdkOperations {
  signInWithCustomToken(auth: Auth, token: string): Promise<UserCredential>;
  collection(
    firestore: Firestore,
    path: string
  ): CollectionReference<DocumentData>;
  query(
    source: Query<DocumentData>,
    constraints: QueryConstraint[]
  ): Query<DocumentData>;
  where(
    field: string,
    operation: WhereFilterOp,
    value: unknown
  ): QueryConstraint;
  orderBy(field: string, direction: 'asc' | 'desc'): QueryConstraint;
  limit(count: number): QueryConstraint;
  onSnapshot(
    source: Query<DocumentData>,
    onNext: (snapshot: QuerySnapshot<DocumentData>) => void,
    onError: (error: unknown) => void
  ): () => void;
}

export const FIREBASE_SDK_OPERATIONS = new InjectionToken<
  FirebaseSdkOperations
>('FIREBASE_SDK_OPERATIONS', {
  providedIn: 'root',
  factory: () => ({
    signInWithCustomToken,
    collection,
    query: (source, constraints) => query(source, ...constraints),
    where,
    orderBy,
    limit,
    onSnapshot
  })
});
